import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { withRouter } from 'react-router';
import RibbonAccount from './dov-account/ribbon-account';
import ribbonContext from '../../stores/ribbon-store';
import { useTabQueryString } from '../../hooks/use-tab-query-string';

const useStyles = makeStyles({
  tabs: {
    paddingBottom: 20,
  },
  tab: {
    width: 220,
  },
});

const RibbonGroup = () => {
  const classes = useStyles();
  const ribbon = React.useContext(ribbonContext);
  const { tab, setTab } = useTabQueryString('account');

  React.useEffect(() => {
    ribbon.fetch();
  }, [ribbon]);

  return (
    <div data-testid="ribbon">
      <Tabs
        value={tab}
        onChange={(_, selectedTab) => setTab(selectedTab)}
        className={classes.tabs}
      >
        <Tab value="account" className={classes.tab} label="Account" />
      </Tabs>
      <div css="position: relative;">
        <div css="position: absolute; width: 100%;">
          {tab === 'account' && <RibbonAccount source={ribbon} />}
        </div>
      </div>
    </div>
  );
};

export default withRouter(RibbonGroup);
